import { SENSORS, sensorLabel } from './montage'

/**
 * The eight sensor-lobe pairs, for assistive technology.
 *
 * The canvas is `aria-hidden` decoration and nothing on it is focusable (O4),
 * so this is how a screen reader learns what the illustration shows. It is
 * built from the `SENSORS` constant and rendered OUTSIDE the `Suspense`
 * boundary, so the pairs are present before the canvas chunk loads, in jsdom,
 * and when the chunk fails to load at all.
 *
 * It names the pairs and says nothing about them. The coverage line belongs to
 * the popover, which is a pointer enhancement.
 */
export function SensorList() {
  return (
    <ul className="visually-hidden" aria-label="Sensors">
      {SENSORS.map((sensor) => (
        <li key={sensor.name}>{sensorLabel(sensor)}</li>
      ))}
    </ul>
  )
}
